import { createContext, use, useMemo } from 'react'
import { RouterProvider, createBrowserRouter } from 'react-router'
import Root from './components/Root'
import AppLauncher from './pages/AppLauncher'
import { APP_LAUNCHER, LOGIN_ROOT } from './constants/routes'
import emptyBrandingSettings from './constants/emptyBrandingSettings'

const AppPropsContext = createContext({})

const useAppProps = () => use(AppPropsContext)

const RootRoute = () => {
  const props = useAppProps()
  const brandingSettings = props.brandingSettings || emptyBrandingSettings
  return (
    <Root
      csrf={props.csrf}
      localLoginEnabled={props.localLoginEnabled}
      identityProviders={props.identityProviders}
      showCaptcha={props.showCaptcha}
      showGoogleFooterLink={props.showGoogleFooterLink}
      disclaimerEnabled={props.disclaimerEnabled}
      siteKey={props.siteKey}
      brandAssetsURL={props.brandAssetsURL}
      talkdeskIdAssetsURL={props.talkdeskIdAssetsURL}
      marketingBannerURL={props.marketingBannerURL}
      marketingBannerTimeout={props.marketingBannerTimeout}
      brandingSettings={brandingSettings}
      metadata={props.metadata}
      sidebannerEnabled={props.sidebannerEnabled}
      email={props.email}
    />
  )
}

const AppLauncherRoute = () => {
  const props = useAppProps()
  const brandingSettings = props.brandingSettings || emptyBrandingSettings
  return (
    <AppLauncher
      metadata={props.metadata}
      brandAssetsURL={props.brandAssetsURL}
      brandingSettings={brandingSettings}
    />
  )
}

const RouterRoot = (props) => {
  const router = useMemo(
    () =>
      createBrowserRouter([
        { path: LOGIN_ROOT, element: <RootRoute /> },
        { path: APP_LAUNCHER, element: <AppLauncherRoute /> },
      ]),
    [],
  )

  return (
    <AppPropsContext value={props}>
      <RouterProvider router={router} />
    </AppPropsContext>
  )
}

export default RouterRoot
